<template>
<div class="my-company">

    <vue-headful
        title="Design Box - Change Parent"
        description="Design Box"
    />

    <div class="container">
        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'change-parent'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <Breadcrumbs/>
                <hr>
                <div class="content">
                    <parent-tree v-for="p in getPossibleParents" :key="p.id"
                        :parent="p" :level="0" :current="getCurrentParent"
                    >
                    </parent-tree>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions, mapState }         from 'vuex'
import ParentTree           from '@/components/company/ParentTree'
import MenuVert             from '@/components/MenuVert'
import Breadcrumbs          from '@/components/Breadcrumbs'

export default {
    name: "ChangeParent",
    components:{
        MenuVert, Breadcrumbs, ParentTree
    },
    computed: {
        ...mapGetters([
            "getCurrentCompany", "getCompany", "getPossibleParents",
            "getCurrentParent"
        ])
    },
    methods: {
        ...mapActions (["loadPossibleParents"])
    },
    mounted () {
        this.loadPossibleParents ({company: this.getCompany, self: this})
    }
}
</script>
